import { createSlice } from "@reduxjs/toolkit";

import { ICustomer } from "@/interfaces/customer.interface";
import { UserProps } from "@/interfaces/interfaces";
import { IWorkspace } from "@/interfaces/workspace.interface";

const getInitialUserData = (): UserProps | null => {
  try {
    return JSON.parse(localStorage.getItem("userData") || "") as UserProps;
  } catch {
    return null;
  }
};
const getInitialUserToken = (): UserProps | null => {
  try {
    return localStorage.getItem("token") as unknown as UserProps;
  } catch {
    return null;
  }
};
const getWorkspaceData = (): IWorkspace | null => {
  try {
    return JSON.parse(localStorage.getItem("workspaceData") || "null");
  } catch {
    return null;
  }
};
const getCustomerData = (): ICustomer | null => {
  try {
    return JSON.parse(localStorage.getItem("customer-data") || "{}");
  } catch {
    return null;
  }
};

const isSyncWithXero = (workspace: IWorkspace | null): boolean => {
  if (!workspace) {
    return false;
  }

  return workspace?.isSyncedWithXero || false;
};

const initialState = {
  userData: getInitialUserData(),
  userToken: getInitialUserToken(),
  workspaceData: getWorkspaceData(),
  customerData: getCustomerData(),
  isWorkspaceConnectedWithXero: false,
};
export const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    refetchUserData: (state) => {
      state.userData = getInitialUserData();
      state.userToken = getInitialUserToken();
    },
    refetchWorkspaceData: (state) => {
      state.workspaceData = getWorkspaceData();
    },
    refetchCustomerData: (state) => {
      state.customerData = getCustomerData();
    },
    setWorkspaceSyncedWithXero: (state, action) => {
      state.isWorkspaceConnectedWithXero = action.payload;
    },
    refetchWorkspaceSyncedWithXero: (state) => {
      state.isWorkspaceConnectedWithXero = isSyncWithXero(state.workspaceData);
    },
  },
});

export const {
  refetchUserData,
  refetchWorkspaceData,
  refetchCustomerData,
  setWorkspaceSyncedWithXero,
  refetchWorkspaceSyncedWithXero,
} = userDataSlice.actions;
export default userDataSlice.reducer;
